import * as api from "../api/index";
import { saveAs } from "file-saver";
import { START_LOADING, END_LOADING, FETCH_CHECKS } from "./constants";

export const getChecksAction = (searchQuery) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });

    const { data } = await api.fetchChecks(searchQuery);

    dispatch({ type: FETCH_CHECKS, payload: data.data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    dispatch({ type: END_LOADING });
    console.log(error.response);
  }
};
export const downloadChecksAction =
  (checksData, setOpen) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });

      await api.downloadPdfChecks(checksData);

      const { data } = await api.fetchPdfChecks();
      const pdfBlob = new Blob([data], { type: "application/pdf" });

      saveAs(pdfBlob, "checks.pdf");
      await api.updateChecks({
        ids: checksData.checks.map((e) => e._id),
        deliveryId: checksData.deliveryID,
      });
      window.location.reload();
      dispatch({ type: END_LOADING });
      setOpen(false);
    } catch (error) {
      dispatch({ type: END_LOADING });
      console.log(error.response);
    }
  };

export const payChecksAction = (payment) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });

    await api.createCheckPayment(payment);

    window.location.reload();
    dispatch({ type: END_LOADING });
  } catch (error) {
    dispatch({ type: END_LOADING });
    console.log(error.response);
  }
};
export const updateChecksAction = (payment) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });

    await api.updateCheckPayment(payment);

    window.location.reload();
    dispatch({ type: END_LOADING });
  } catch (error) {
    dispatch({ type: END_LOADING });
    console.log(error.response);
  }
};

export const getExistingChecks = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });

    const { data } = await api.fetchExistingChecks();
    dispatch({ type: FETCH_CHECKS, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    dispatch({ type: END_LOADING });
    console.log(error.response);
  }
};
